import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { publicColors, publicContainerSx, publicH2Sx, publicSectionSx, publicSubtitleSx } from './publicTheme';

const reasons = [
    'Feito por quem vende impressão 3D — fluxos alinhados à produção de 3D, não a varejo genérico.',
    'Métricas de produção, precificação, vendas e financeiro no mesmo lugar: menos planilha, menos retrabalho.',
    'Integração com impressoras para não depender só de lançamento manual. *',
    'Evolução guiada por feedback de makers — toda sugestão é muito bem vinda!',
];

const WhyUs = () => (
    <Box id="mais-motivos" component="section" sx={{ ...publicSectionSx, bgcolor: publicColors.surfaceAlt }}>
        <Box sx={publicContainerSx}>
            <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={5}>
                    <Typography component="h2" sx={publicH2Sx}>
                        Por que não uma planilha?
                    </Typography>
                    <Typography sx={{ ...publicSubtitleSx, mx: 0, textAlign: 'left' }}>
                        Planilha não avisa quando a impressora mais cara está com taxa de falha alta,
                        nem cruza pedido com custo de energia e filamento. O Acompanha 3D existe para
                        essa lacuna: gestão com estatísticas acionáveis.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Stack spacing={2}>
                        {reasons.map((text) => (
                            <Stack key={text} direction="row" spacing={1.5} alignItems="flex-start">
                                <CheckCircleOutlineIcon sx={{ color: publicColors.accent, mt: 0.25, flexShrink: 0 }} />
                                <Typography sx={{ color: publicColors.inkMuted, lineHeight: 1.65 }}>{text}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    </Box>
);

export default WhyUs;
